import React, {useEffect, useState} from 'react';
import PageButton from '../../elements/PageButton/PageButton';
import Pagination from '../../elements/Pagination/Pagination';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';
import {API_BASE} from '../../../utils/apiConfig';
import {MENU_SOUND_MANAGER} from '../../../scenes/MenuSoundManager';
import {RatingCrystalsRewardRow} from './RatingCrystalsRewardRow';
import {RatingCrystalsInfo} from './RatingCrystalsInfo';
import '../MatchHistoryPage/MatchHistoryPage.css';
import './RatingCrystalsPage.css';

const PAGE_ID = 'RatingCrystalsPage';
const PAGE_SIZE = 10;

/**
 * История ежедневных начислений кристаллов за рейтинг. Один компонент на два
 * случая (как MatchHistoryPage): свои начисления в профиле и все начисления
 * всем игрокам в админке — различаются только эндпоинтом и колонкой с ником.
 */
function RatingCrystalsPage({isAllUsers = false, userId, userName, onBack}) {
  const [rewards, setRewards] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  usePageAnalytics(PAGE_ID);

  useEffect(() => {
    const fetchRewards = async () => {
      setLoading(true);
      setError(null);
      try {
        // Три режима: все начисления (админка), чужая история (админ смотрит
        // профиль игрока) и своя
        let url = `${API_BASE}/users/me/rating-crystals?limit=${PAGE_SIZE}&page=${page}`;
        if (isAllUsers) {
          url = `${API_BASE}/admin/rating-crystals?limit=${PAGE_SIZE}&page=${page}`;
        } else if (userId) {
          url = `${API_BASE}/users/${userId}/rating-crystals?limit=${PAGE_SIZE}&page=${page}`;
        }
        const res = await fetch(url, {credentials: 'include'});
        if (!res.ok) throw new Error('Failed to fetch rating crystals history');
        const data = await res.json();
        setRewards(data.rewards || []);
        setTotalPages(data.totalPages || 1);
      } catch (e) {
        console.error('Rating crystals history error', e);
        setError('Не удалось загрузить историю начислений');
      } finally {
        setLoading(false);
      }
    };

    fetchRewards();
  }, [page, isAllUsers, userId]);

  const handlePageChange = (newPage) => {
    MENU_SOUND_MANAGER.playMenuButtonClick();
    setPage(newPage);
  };

  return (
    <>
      <h1 className={`admin-user-profile-title ${userName ? '' : 'history-page-title-margin-bottom'}`}>
        Кристаллы за рейтинг
      </h1>

      {/* Чей профиль смотрим — как на странице истории матчей */}
      {userName && <h1 className={'admin-user-profile-name'}>{userName}</h1>}

      {/* Правила начисления показываем игроку; в общем списке админки они ни к
          чему */}
      {!isAllUsers && <RatingCrystalsInfo/>}

      {loading && <p className={'match-history-page-status'}>Загрузка...</p>}
      {error && <p className={'match-history-page-status match-history-page-status_error'}>{error}</p>}

      {!loading && !error && (
        <>
          {rewards.length === 0 ? (
            <p className={'match-history-page-status'}>Пока нет начислений</p>
          ) : (
            <>
              <div className={'rating-crystals-page_list'}>
                {rewards.map((reward) => (
                  <RatingCrystalsRewardRow
                    key={reward.id}
                    reward={reward}
                    showUserName={isAllUsers}
                  />
                ))}
              </div>
              <Pagination currentPage={page} totalPages={totalPages} onPageChange={handlePageChange}/>
            </>
          )}
        </>
      )}

      <div className={'main-menu-buttons match-history-page-buttons'}>
        <PageButton onClick={onBack} pageId={PAGE_ID} buttonId={'back'}>
          Назад
        </PageButton>
      </div>
    </>
  );
}

export default RatingCrystalsPage;
